module.exports = __webpack_public_path__ + "img/aboutus_banner.417db3ac.png";